/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-add-task',
    templateUrl: './add-task.component.html',
    styleUrls: ['./add-task.component.scss'],
    standalone: false
})
export class AddTaskComponent implements OnInit {
    @Input() buttonColor: string = 'primary';
    @Output() taskAdded = new EventEmitter<any>();
    @Output() inputChanged = new EventEmitter<any>();
    public taskTitle: string = '';

    addTask() {
        if (this.taskTitle !== undefined && this.taskTitle.trim() !== '') {
            this.taskAdded.emit(this.taskTitle.trim());
            this.taskTitle = '';
            // Also tell the parent that the "unsaved typed-but-not-added text"
            // is gone. Without this the parent keeps `hasUnsavedTask = true`
            // with the stale value, and on submit re-adds the same task,
            // creating a duplicate row in the database.
            this.inputChanged.emit('');
        }
    }

    public ngOnInit(): void {
    }

    public onInputEntered() {
        this.inputChanged.emit(this.taskTitle);
    }
}
